var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manager-login"},[_c('Header'),_c('div',{staticClass:"main-content"},[_c('h1',{staticClass:"main-heading"},[_vm._v("学校管理者ログイン")]),_c('LoginForm'),_c('div',{staticClass:"move-link"},[_vm._v(" パスワードを忘れた方は "),_c('router-link',{attrs:{"data-cy":"linkResetPass","to":{
          name: 'OResetPass',
        }}},[_vm._v(" こちら ")])],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }